import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpHelperService } from 'src/app/services/http-helper/http-helper.service';

@Injectable({
  providedIn: 'root',
})
export class HttpResolverService implements Resolve<any> {
  private httpHelper = inject(HttpHelperService);

  constructor() {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.httpHelper.getInfo();
  }
}
